<app-navbar></app-navbar>

<div class="container-fluid">
    <!-- Filtros -->
    <div class="card shadow-sm filtros-modernas border-0 mb-4">
        <div class="card-header d-flex align-items-center rounded-top">
            <i class="fas fa-search fs-5 me-2 text-white"></i>
            <h2 class="fw-bold">Roteiro</h2>
        </div>
        <div class="card-body">
            <div class="row g-3 align-items-end">
                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-person"></i> Nome do Usuário</label>
                    <select class="form-select" [(ngModel)]="filtroUsuarioId" (change)="aplicarFiltroAutomatico()">
                        <option value="">Selecione um usuário</option>
                        <option *ngFor="let usuario of usuariosFiltro" [value]="usuario.usuarioId">{{ usuario.nome }}
                        </option>
                    </select>
                </div>

                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-calendar-event"></i> Data Início</label>
                    <input type="date" class="form-control" [(ngModel)]="filtroDataInicio" />
                </div>

                <div class="col-md-3">
                    <label class="form-label"><i class="bi bi-calendar-event"></i> Data Fim</label>
                    <input type="date" class="form-control" [(ngModel)]="filtroDataFim" />
                </div>

                <!-- Status select moved to the table header for easier access -->

                <div class="col-md-3 d-flex gap-2 consultar">
                    <button class="btn btn-gradient-primary w-50" (click)="aplicarFiltro()">
                        <i class="bi bi-funnel-fill me-1"></i> Consultar
                    </button>
                    <button class="btn btn-warning w-50" (click)="resetarFiltro()">
                        <i class="bi bi-arrow-clockwise me-1"></i> Limpar
                    </button>
                </div>
            </div>

        </div>

        <div *ngIf="filtroUsuarioId && filtroAplicado">
            <div class="modern-card card-summary-container">
                <div class="cards-container">
                    <div class="card-box blue">
                        <div class="icon"><i class="fas fa-file-alt"></i></div>
                        <div class="value">{{ cadastroStatusTotal }}</div>
                        <div class="label">Cadastro</div>
                    </div>

                    <div class="card-box purple">
                        <div class="icon"><i class="fas fa-sync-alt"></i></div>
                        <div class="value">{{ recadastroStatusTotal }}</div>
                        <div class="label">Recadastro</div>
                    </div>

                    <div class="card-box orange">
                        <div class="icon"><i class="fas fa-exclamation-circle"></i></div>
                        <div class="value">{{ pendingBothCount }}</div>
                        <div class="label">Pendente</div>
                    </div>

                    <div class="card-box orange">
                        <div class="icon"><i class="fas fa-clock"></i></div>
                        <div class="value">{{ tempoMedioExecucao }}</div>
                        <div class="label">Tempo Médio Execução</div>
                    </div>
                </div>
            </div>

            <!-- Mapas -->
            <div class="maps-container">
                <div class="map-box">
                    <h3>Ultima Localização</h3>
                    <div id="mapUserLocation" class="map"></div>
                </div>

                <div class="map-box">
                    <h3>Roteiro do Período</h3>
                    <!-- Select para escolher o dia do roteiro -->
                    <div *ngIf="datasDisponiveisMapa.length > 1" class="map-dia-select">
                        <label for="selectDataMapa" style="font-weight:600; margin-right:8px;">Selecionar dia:</label>
                        <select id="selectDataMapa" class="form-select form-select-sm d-inline-block w-auto"
                            [(ngModel)]="dataSelecionadaMapa" (change)="onChangeDataMapa(dataSelecionadaMapa)">
                            <option *ngFor="let data of datasDisponiveisMapa" [value]="data">
                                {{ data | date:'dd/MM/yyyy' }}
                            </option>
                        </select>
                    </div>
                    <div id="mapShiftLocation" class="map"></div>
                    <div class="map-legend">
                        <div>Os números indicam a ordem cronológica das visitas</div>
                    </div>
                </div>
            </div>

            <div class="user-info-container">
                <h3>Dados Técnico</h3>
                <div class="modern-card ">
                    <div class="user-horizontal-wrapper">
                        <!-- Avatar + Status -->
                        <div class="avatar-status">
                            <div class="user-avatar"
                                [ngStyle]="{ 'background-image': fotoPerfil ? 'url(' + fotoPerfil + ')' : 'none' }">
                                <span *ngIf="!fotoPerfil">{{ nomeUsuario.charAt(0) }}</span>
                            </div>
                            <div class="status-badge"
                                [ngClass]="{ 'online': userData?.isOnline, 'offline': !userData?.isOnline }">
                                {{ userData?.isOnline ? 'Online' : 'Offline' }}
                            </div>
                        </div>

                        <!-- Campos -->
                        <div class="user-fields-grid">
                            <div class="info-item"><label>Nome</label><span>{{ userData?.nome }}</span></div>
                            <div class="info-item"><label>Usuário</label><span>{{ userData?.userName }}</span></div>
                            <div class="info-item"><label>CPF</label><span>{{ userData?.cpf }}</span></div>
                            <div class="info-item"><label>Função</label><span>{{ userData?.role }}</span></div>
                            <div class="info-item"><label>Empresa</label><span>{{ getEmpresaNome(userData?.empresa)
                                    }}</span></div>
                            <div class="info-item"><label>Nº Funcional</label><span>{{ userData?.numeroMatricula
                                    }}</span>
                            </div>
                            <div class="info-item"><label>Email</label><span>{{ userData?.email }}</span></div>
                            <div class="info-item"><label>Última Autenticação</label><span>{{
                                    userData?.dataHoraUltimaAutenticacao |
                                    date:'dd/MM/yyyy HH:mm:ss' }}</span></div>
                        </div>
                        <div class="phone-frame"
                            *ngIf="dispositivosUsuario && dispositivosUsuario.length > 0; else noDevice">
                            <div class="phone-screen">
                                <div class="device-info">
                                    <ng-container *ngIf="dispositivosUsuario[0] as disp">
                                        <p><b>App:</b> {{ disp.appName || 'VibeTex CEDAE' }}</p>
                                        <p><b>Marca:</b> {{ disp.marca || '-' }}</p>
                                        <p><b>Modelo:</b> {{ disp.modelo || '-' }}</p>
                                        <p><b>Sistema:</b> {{ disp.sistema || '-' }}</p>
                                        <p><b>IP Local:</b> {{ disp.ipLocal || '-' }}</p>
                                        <p><b>Conexão:</b> {{ disp.conexaoFormatada || '-' }}</p>
                                        <p>
                                            <b>Bateria:</b>
                                            <span [ngClass]="{
                                                    'bateria-verde': (getNivelBateriaNum(disp) || 0) >= 80,
                                                    'bateria-amarela': (getNivelBateriaNum(disp) || 0) >= 30 && (getNivelBateriaNum(disp) || 0) < 80,
                                                    'bateria-vermelha': (getNivelBateriaNum(disp) || 0) < 30,
                                                    'bateria-carregando': disp?.estaCarregando === true
                                                }" class="bateria-destaque"
                                                [style.--bateria-percent]="(getNivelBateriaNum(disp) || 0) + '%'">
                                                <ng-container *ngIf="disp?.estaCarregando; else mostrarNivel">
                                                    {{ disp.nivelBateria || '-' }}%
                                                </ng-container>
                                                <ng-template #mostrarNivel>
                                                    {{ disp.nivelBateria || '-' }}%
                                                </ng-template>
                                            </span>
                                        </p>
                                        <p><b>Versão:</b> {{ disp.version || '-' }}</p>
                                        <p><b>Atualização:</b> {{ disp.dataAtualizacao ? (disp.dataAtualizacao |
                                            date:'dd/MM/yyyy HH:mm:ss') : '-' }}</p>
                                    </ng-container>
                                    <div *ngIf="dispositivosUsuario.length > 1" class="more-devices mt-3">
                                        <h6>Outros dispositivos</h6>
                                        <ul>
                                            <li *ngFor="let d of dispositivosUsuario; let i = index" [hidden]="i===0">
                                                {{ d.marca || '-' }} • {{ d.modelo || d.appName || '-' }} • {{ d.sistema
                                                || '-' }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <ng-template #noDevice>
                            <div class="device-mockup">
                                <div class="device-screen d-flex align-items-center justify-content-center p-4">
                                    <div class="text-center">
                                        <i class="fas fa-exclamation-circle fa-2x text-warning"></i>
                                        <div class="mt-2">Nenhum dispositivo encontrado para este usuário.</div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- Nova Tabela Unificada para Cadastros e Recadastramentos -->
            <div class="table-container">
                <div class="d-flex justify-content-between align-items-center mb-3"
                    *ngIf="filtroAplicado || filtroStatus || (registrosUnificados && registrosUnificados.length > 0)">
                    <h3 class="mb-0">Registros do Período {{ filtroDataInicio | date:'dd/MM/yyyy' }} a {{ filtroDataFim
                        |
                        date:'dd/MM/yyyy' }}</h3>

                    <div class="d-flex align-items-center gap-2">
                        <label class="mb-0 small" style="font-weight:600; margin-right:6px;">Status:</label>
                        <select class="form-select form-select-sm" [(ngModel)]="filtroStatus" (change)="paginaAtualRegistros=1">
                            <option value="">Todos</option>
                            <option value="Concluida">Concluída</option>
                            <option value="Negada">Negada</option>
                            <option value="Retornar">Retornar</option>
                            <option value="Pendente">Pendente</option>
                        </select>

                        <button class="btn btn-success" (click)="exportarParaExcel()">
                            <i class="bi bi-file-earmark-excel me-1"></i> Exportar para Excel
                        </button>
                    </div>
                </div>
                <div class="table-responsive table-responsive-mobile">
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th style="min-width: 110px;">Nº Vistoria</th>
                                <th>Consumidor</th>
                                <th>Matrícula</th>
                                <th>Data</th>
                                <th>Endereço</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of registrosPaginaAtual"
                                [ngClass]="{'cadastro-row': item.tipo === 'cadastro', 'recadastro-row': item.tipo === 'recadastro'}">
                                <td class="tipo-cell">
                                    <span class="tipo-badge"
                                        [ngClass]="{'cadastro-badge': item.tipo === 'cadastro', 'recadastro-badge': item.tipo === 'recadastro'}">
                                        {{ item.tipo === 'cadastro' ? 'Cadastro' : 'Recadastro' }}
                                    </span>
                                </td>
                                <td>
                                    <span class=" n-vistoria" title="{{ formatNumeroOS(item) }}">{{
                                        formatNumeroOS(item) }}</span>
                                </td>
                                <td>{{item.nomeConsumidor}}</td>
                                <td>{{ item.matricula ? item.matricula : 'Sem Dados' }}</td>
                                <td>
                                    {{
                                    item.tipo === 'cadastro'
                                    ? (item.dataCadastroOriginal | date:'dd/MM/yyyy:HH:mm:ss')
                                    : (item.dataRecadastramento | date:'dd/MM/yyyy:HH:mm:ss')
                                    }}
                                </td>
                                <td>{{item.endereco?.logradouro}}, {{item.endereco?.numero}} - {{item.endereco?.bairro}}
                                </td>
                                <td>
                                    <span class="status-badge" [ngClass]="{
                                            'badge-concluida': item.statusOS === 'Concluida',
                                            'badge-pendente': item.statusOS === 'Pendente',
                                            'badge-cancelada': item.statusOS === 'Cancelada',
                                            'badge-em-andamento': item.statusOS === 'EmAndamento',
                                            'badge-negada': item.statusOS === 'Invalido' || item.statusOS === 'Negada',
                                            'badge-retornar': item.statusOS === 'Retornar'
                                        }">
                                        {{ item.statusOS }}
                                    </span>
                                </td>
                                <td class="actions-cell">
                                    <button class="btn-action" (click)="abrirFormulario(item)" title="Ver Formulário"
                                        [ngClass]="{'cadastro-btn': item.tipo === 'cadastro', 'recadastro-btn': item.tipo === 'recadastro'}">
                                        <i class="fas fa-file-alt"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="registrosPaginaAtual.length === 0">
                                <td colspan="8" class="text-center">
                                    Nenhum registro encontrado para o período selecionado
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Controles de Paginação -->
                <div class="pagination-container mt-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <!-- Informações da paginação -->
                        <div class="pagination-info">
                            <span class="text-muted">
                                Mostrando {{ (paginaAtualRegistros - 1) * tamanhoPaginaRegistros + 1 }}
                                a {{ paginaAtualRegistros * tamanhoPaginaRegistros > (filtroStatus ? registrosFiltrados.length : totalItensRegistros) ?
                                (filtroStatus ? registrosFiltrados.length : totalItensRegistros) : paginaAtualRegistros * tamanhoPaginaRegistros }}
                                de {{ (filtroStatus ? registrosFiltrados.length : totalItensRegistros) }} registros
                            </span>
                        </div>

                        <!-- Seletor de tamanho da página -->
                        <div class="page-size-selector">
                            <label class="me-2">Itens por página:</label>
                            <select class="form-select form-select-sm d-inline-block w-auto"
                                [(ngModel)]="tamanhoPaginaRegistros"
                                (change)="mudarTamanhoPaginaRegistros(tamanhoPaginaRegistros)">
                                <option [value]="5">5</option>
                                <option [value]="10">10</option>
                                <option [value]="25">25</option>
                                <option [value]="50">50</option>
                                <option [value]="100">100</option>
                            </select>
                        </div>

                        <!-- Controles de navegação -->
                        <div class="pagination-controls">
                            <nav aria-label="Navegação da tabela">
                                <ul class="pagination pagination-sm mb-0">
                                    <!-- Primeira página -->
                                    <li class="page-item" [class.disabled]="paginaAtualRegistros === 1">
                                        <button class="page-link" (click)="mudarPaginaRegistros(1)"
                                            [disabled]="paginaAtualRegistros === 1">
                                            <i class="fas fa-angle-double-left"></i>
                                        </button>
                                    </li>

                                    <!-- Página anterior -->
                                    <li class="page-item" [class.disabled]="paginaAtualRegistros === 1">
                                        <button class="page-link"
                                            (click)="mudarPaginaRegistros(paginaAtualRegistros - 1)"
                                            [disabled]="paginaAtualRegistros === 1">
                                            <i class="fas fa-angle-left"></i>
                                        </button>
                                    </li>

                                    <!-- Páginas numeradas -->
                                    <ng-container
                                        *ngFor="let pagina of [].constructor(totalPaginasRegistros); let i = index">
                                        <li class="page-item" [class.active]="(i + 1) === paginaAtualRegistros"
                                            *ngIf="(i + 1) >= paginaAtualRegistros - 2 && (i + 1) <= paginaAtualRegistros + 2">
                                            <button class="page-link" (click)="mudarPaginaRegistros(i + 1)">
                                                {{ i + 1 }}
                                            </button>
                                        </li>
                                    </ng-container>

                                    <!-- Próxima página -->
                                    <li class="page-item"
                                        [class.disabled]="paginaAtualRegistros === totalPaginasRegistros">
                                        <button class="page-link"
                                            (click)="mudarPaginaRegistros(paginaAtualRegistros + 1)"
                                            [disabled]="paginaAtualRegistros === totalPaginasRegistros">
                                            <i class="fas fa-angle-right"></i>
                                        </button>
                                    </li>

                                    <!-- Última página -->
                                    <li class="page-item"
                                        [class.disabled]="paginaAtualRegistros === totalPaginasRegistros">
                                        <button class="page-link" (click)="mudarPaginaRegistros(totalPaginasRegistros)"
                                            [disabled]="paginaAtualRegistros === totalPaginasRegistros">
                                            <i class="fas fa-angle-double-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="mostrarFormulario" class="form-cadastro-container">
                <form class="form px-2 py-2">

                    <div class="mb-3">
                        <div class="p-3 rounded bg-gradient-info d-flex align-items-center">
                            <i class="fas fa-search fs-4 me-3"></i>
                            <div>
                                <div class="small">Vistoria</div>
                                <div class="h5 fw-bold mb-0">n° {{ formatNumeroOS(CadastroSelecionado) }}</div>
                            </div>
                        </div>
                    </div>

                    <fieldset>
                        <legend class="mb-2">Dados do Consumidor</legend>
                        <div class="grid-2 mb-2">
                            <div
                                *ngIf="getTipoServico(CadastroSelecionado) === 'recadastro' && CadastroSelecionado?.matricula">
                                <label>Matrícula</label>
                                <input type="text" [value]="CadastroSelecionado?.matricula" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nome do Consumidor</label>
                                <input type="text" [value]="CadastroSelecionado?.nomeConsumidor || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>
                                    <ng-container
                                        *ngIf="CadastroSelecionado?.tipoUtilizacao === 'DOMICILIAR'; else cnpjLabel">
                                        CPF
                                    </ng-container>
                                    <ng-template #cnpjLabel>CNPJ</ng-template>
                                </label>
                                <input type="text"
                                    [value]="CadastroSelecionado?.tipoUtilizacao === 'DOMICILIAR' ? maskCpf(CadastroSelecionado?.cpf || '') : maskCnpj(CadastroSelecionado?.cnpj || '')"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-4 mb-2">
                            <div *ngIf="CadastroSelecionado?.email">
                                <label>Email</label>
                                <input type="text" [value]="CadastroSelecionado?.email || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Telefone</label>
                                <input type="text" [value]="maskTelefone(CadastroSelecionado?.telefone || '')" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Ciclo de Leitura</label>
                                <input type="text" [value]="CadastroSelecionado?.cicloDeLeitura || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Número Imóvel</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroImovel || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-4 mb-2">
                            <div>
                                <label>Referência</label>
                                <input type="text" [value]="CadastroSelecionado?.referencia || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Data Cadastro</label>
                                <input type="text"
                                    [value]="CadastroSelecionado?.dataHoraInicio | date: 'dd/MM/yyyy HH:mm'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Loja/Loc</label>
                                <input type="text" [value]="CadastroSelecionado?.lojLoc || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-3 mb-2">
                            <div>
                                <label>Sistema de Abastecimento</label>
                                <input type="text" [value]="CadastroSelecionado?.sistemaAbastecimento || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo de Abastecimento</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoAbastecimento || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo Utilização</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoUtilizacao || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset
                        *ngIf="CadastroSelecionado?.numeroHidrometro || CadastroSelecionado?.marcacao || CadastroSelecionado?.seloReloj || CadastroSelecionado?.seloVirola || CadastroSelecionado?.ramal || CadastroSelecionado?.direto !== undefined || CadastroSelecionado?.haCisterna !== undefined || CadastroSelecionado?.haReservatorioElevado !== undefined || CadastroSelecionado?.tipoEconomia || CadastroSelecionado?.haPiscina !== undefined">
                        <legend class="mb-2">ÁGUA</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Nº Hidrômetro</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroHidrometro || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Marcação</label>
                                <input type="text" [value]="CadastroSelecionado?.marcacao || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Selo Reloj.</label>
                                <input type="text" [value]="CadastroSelecionado?.seloReloj || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Selo Virola</label>
                                <input type="text" [value]="CadastroSelecionado?.seloVirola || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Ramal</label>
                                <input type="text" [value]="CadastroSelecionado?.ramal || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Direto</label>
                                <input type="text"
                                    [value]="CadastroSelecionado?.direto === undefined ? '-' : (CadastroSelecionado?.direto ? 'Sim' : 'Não')"
                                    readonly class="campo-readonly" />
                            </div>
                        </div>

                        <div class="grid-1 mb-2">

                            <fieldset *ngIf="CadastroSelecionado?.haCisterna !== undefined">
                                <h4>Cisterna</h4>
                                <label>Há cisterna?</label>
                                <input type="text" [value]="CadastroSelecionado?.haCisterna ? 'Sim' : 'Não'" readonly
                                    class="campo-readonly" />
                                <div
                                    *ngIf="CadastroSelecionado?.haCisterna && CadastroSelecionado?.capacidadeCisternaInformada">
                                    <label>Capacidade Informada</label>
                                    <input type="text" [value]="CadastroSelecionado?.capacidadeCisternaInformada"
                                        readonly class="campo-readonly" />
                                </div>
                                <div
                                    *ngIf="CadastroSelecionado?.haCisterna && CadastroSelecionado?.observacoesCisterna">
                                    <label>Observações</label>
                                    <textarea readonly class="campo-readonly"
                                        rows="2">{{ CadastroSelecionado?.observacoesCisterna }}</textarea>
                                </div>
                            </fieldset>

                            <fieldset *ngIf="CadastroSelecionado?.haReservatorioElevado !== undefined">
                                <h4>Reservatório Elevado</h4>
                                <label>Há Reservatórios Elevados?</label>
                                <input type="text" [value]="CadastroSelecionado?.haReservatorioElevado ? 'Sim' : 'Não'"
                                    readonly class="campo-readonly" />
                                <div
                                    *ngIf="CadastroSelecionado?.haReservatorioElevado && CadastroSelecionado?.capacidadeReservatorioElevadoInformada">
                                    <label>Capacidade Informada</label>
                                    <input type="text"
                                        [value]="CadastroSelecionado?.capacidadeReservatorioElevadoInformada" readonly
                                        class="campo-readonly" />
                                </div>
                                <div
                                    *ngIf="CadastroSelecionado?.haReservatorioElevado && CadastroSelecionado?.observacoesReservatorioElevado">
                                    <label>Observações</label>
                                    <textarea readonly class="campo-readonly"
                                        rows="2">{{ CadastroSelecionado?.observacoesReservatorioElevado }}</textarea>
                                </div>
                            </fieldset>

                            <fieldset *ngIf="CadastroSelecionado?.haPiscina !== undefined">
                                <h4>Piscina</h4>
                                <label>Existe Piscina?</label>
                                <input type="text" [value]="CadastroSelecionado?.haPiscina ? 'Sim' : 'Não'" readonly
                                    class="campo-readonly" />
                                <div *ngIf="CadastroSelecionado?.haPiscina && CadastroSelecionado?.dimensoesPiscina">
                                    <label>Dimensões:</label>
                                    <input type="text" [value]="CadastroSelecionado?.dimensoesPiscina" readonly
                                        class="campo-readonly" />
                                </div>
                            </fieldset>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Economias</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Tipos de Economias</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoEconomia || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                            <div *ngIf="CadastroSelecionado?.dUnica">
                                <label>Sub.Categoria</label>
                                <input type="text" [value]="CadastroSelecionado?.dUnica" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Número de Economias</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeEconomias || '-'" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- Domiciliar -->
                        <div class="grid-4 mb-2" *ngIf="CadastroSelecionado?.tipoEconomia === 'DOMICILIAR' ">
                            <div>
                                <label>Nº Quartos</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeQuartos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Salas</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeSalas" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº WC/PAV</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroWcPav" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Boxes</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeBoxes" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Banheiro</label>
                                <input type="text" [value]="CadastroSelecionado?.banheiros" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Área (m²)</label>
                                <input type="text" [value]="CadastroSelecionado?.areaMetroQuadrado" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- COMERCIO -->
                        <div class="grid-3 mb-2" *ngIf="CadastroSelecionado?.tipoEconomia === 'COMERCIO'">
                            <div>
                                <label>Nº Salas/Lojas/Quartos</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeQuartos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Tipo Comércio</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoComercio" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Alunos</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeAlunos" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Boxes</label>
                                <input type="text" [value]="CadastroSelecionado?.numeroDeBoxes" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Nº Banheiro</label>
                                <input type="text" [value]="CadastroSelecionado?.banheiros" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Área (m²)</label>
                                <input type="text" [value]="CadastroSelecionado?.areaMetroQuadrado" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>

                        <!-- Indústria -->
                        <div class="grid-3 mb-2" *ngIf="CadastroSelecionado?.tipoEconomia === 'INDUSTRIA'">
                            <div>
                                <label>Tipo Indústria</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoIndustria" readonly
                                    class="campo-readonly" />
                            </div>
                            <div>
                                <label>Área (m²)</label>
                                <input type="text" [value]="CadastroSelecionado?.areaMetroQuadrado" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">ESGOTO</legend>
                        <div>
                            <label>Tem coletor?</label>
                            <input type="text" [value]="CadastroSelecionado?.haColetor ? 'Sim' : 'Não'" readonly
                                class="campo-readonly" />
                        </div>

                        <div *ngIf="CadastroSelecionado?.haColetor">
                            <label>Efluente encaminhado para:</label>
                            <div class="grid-4 mb-2">
                                <div *ngIf="CadastroSelecionado?.coletor === 'true'">
                                    <label>Coletor</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.gap === 'true'">
                                    <label>GAP</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.rio === 'true'">
                                    <label>RIO</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.valao === 'true'">
                                    <label>VALÃO</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.focaFiltro === 'true'">
                                    <label>Fossa/Filtro</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.vala === 'true'">
                                    <label>Vala</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                                <div *ngIf="CadastroSelecionado?.sumidouro === 'true'">
                                    <label>Sumidouro</label>
                                    <input type="text" value="Sim" readonly class="campo-readonly" />
                                </div>
                            </div>
                            <div *ngIf="CadastroSelecionado?.tipoValaValao">
                                <label>A vala ou valão é de:</label>
                                <input type="text" [value]="CadastroSelecionado?.tipoValaValao" readonly
                                    class="campo-readonly" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Endereço</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Logradouro:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.logradouro || '-'" readonly>
                            </div>
                            <div>
                                <label>Número:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.numero || '-'" readonly>
                            </div>
                            <div>
                                <label>Bairro:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.bairro || '-'" readonly>
                            </div>
                        </div>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Cidade:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.cidade ||  '-'" readonly>
                            </div>
                            <div>
                                <label>Estado:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.estado || '-'" readonly>
                            </div>
                            <div>
                                <label>CEP:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.cep || '-'" readonly>
                            </div>
                        </div>
                        <div class="grid-1 mb-2" *ngIf="CadastroSelecionado?.endereco?.complemento ">
                            <div>
                                <label>Complemento:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.endereco?.complemento ||  '-'" readonly>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">FOTOS DO LOCAL</legend>
                        <div class="fotos-grid mb-2">
                            <div class="foto-item" *ngFor="let foto of CadastroSelecionado?.fotos">
                                <div class="foto-wrapper">
                                    <img [src]="getFullImageUrl(foto.url || '')" alt="Foto do Local" class="foto-local"
                                        (click)="abrirModalFoto(foto.url || '')"
                                        [style.transform]="'rotate(' + getRotacaoMiniatura(foto.url || '') + 'deg)'"
                                        [style.transition]="'transform 0.3s'" />
                                </div>
                                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                                    <a *ngIf="foto?.latitude && foto?.longitude"
                                        [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude"
                                        target="_blank" class="btn btn-outline-success btn-sm">
                                        <i class="bi bi-geo-alt-fill"></i> Mapa
                                    </a>

                                    <button *ngIf="isSuperAdministrador" type="button" class="btn btn-outline-danger btn-sm" title="Excluir foto"
                                        (click)="$event.stopPropagation(); excluirFoto(foto)">
                                        <i class="bi bi-trash"></i>
                                    </button>

                                    <div class="rotate-buttons">
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="$event.stopPropagation(); girarMiniatura(foto.url || '', 'esquerda')" title="Girar esquerda">
                                            <i class="bi bi-arrow-counterclockwise"></i>
                                        </button>
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="$event.stopPropagation(); girarMiniatura(foto.url || '', 'direita')" title="Girar direita">
                                            <i class="bi bi-arrow-clockwise"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!CadastroSelecionado?.fotos?.length" class="alert alert-warning">
                            Nenhuma foto disponível.
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
                        <div>
                            <label>Descrição da Conclusão</label>
                            <textarea readonly class="campo-readonly"
                                rows="6">{{ CadastroSelecionado?.outrasInformacoes }}</textarea>
                        </div>
                    </fieldset>

                    <fieldset *ngIf="CadastroSelecionado?.motivoNegativa">
                        <legend class="mb-2">MOTIVO DA NEGATIVA</legend>
                        <div class="grid-1 mb-2">
                            <div>
                                <label>Descrição da Negativa</label>
                                <textarea readonly class="campo-readonly"
                                    rows="4">{{ CadastroSelecionado?.motivoNegativa }}</textarea>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset *ngIf="CadastroSelecionado?.motivoInvalidacao">

                        <legend class="mb-2">MOTIVO DA INVALIDAÇÃO</legend>
                        <div class="grid-1 mb-2">
                            <div>
                                <label>Descrição da Invalid ação</label>
                                <textarea readonly class="campo-readonly"
                                    rows="4">{{ CadastroSelecionado?.motivoInvalidacao }}</textarea>
                            </div>
                        </div>
                    </fieldset>


                    <fieldset class="fotos">
                        <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
                        <div class="fotos-grid mb-2">
                            <div class="foto-item" *ngFor="let fotoDoc of CadastroSelecionado?.fotosDocumento">
                                <div class="foto-wrapper">
                                    <img [src]="getFullImageUrl(fotoDoc.url || '')" alt="Foto do Documento"
                                        class="foto-local" (click)="abrirModalFoto(fotoDoc.url || '')"
                                        [style.transform]="'rotate(' + getRotacaoMiniatura(fotoDoc.url || '') + 'deg)'"
                                        [style.transition]="'transform 0.3s'" />
                                </div>
                                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                                    <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                                        [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                                        target="_blank" class="btn btn-outline-success btn-sm">
                                        <i class="bi bi-geo-alt-fill"></i> Mapa
                                    </a>

                                    <button *ngIf="isSuperAdministrador" type="button" class="btn btn-outline-danger btn-sm" title="Excluir documento"
                                        (click)="$event.stopPropagation(); excluirFotoDocumento(fotoDoc)">
                                        <i class="bi bi-trash"></i>
                                    </button>

                                    <div class="rotate-buttons">
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url || '', 'esquerda')" title="Girar esquerda">
                                            <i class="bi bi-arrow-counterclockwise"></i>
                                        </button>
                                        <button type="button" class="btn btn-light btn-sm rotate-btn"
                                            (click)="$event.stopPropagation(); girarMiniatura(fotoDoc.url || '', 'direita')" title="Girar direita">
                                            <i class="bi bi-arrow-clockwise"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!CadastroSelecionado?.fotosDocumento?.length" class="alert alert-warning">
                            Nenhuma foto disponível.
                        </div>
                    </fieldset>


                    <fieldset>
                        <legend class="mb-2">Localização</legend>
                        <!-- Two-column cards for Início and Fim do Cadastro -->
                        <div class="grid-2 mb-2 timing-info">
                            <div class="info-box modern-card start-card">
                                <div class="card-header-small d-flex align-items-center mb-2">
                                    <i class="bi bi-play-circle-fill text-primary me-2 fs-4"></i>
                                    <h4 class="m-0">Início do Cadastro</h4>
                                </div>

                                <label>Data/Hora:</label>
                                <div class="mb-2">
                                    <span>{{ CadastroSelecionado?.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </div>

                                <label>Coordenadas:</label>
                                <div class="mb-3">
                                    <span class="coord-pill coord-start"
                                        *ngIf="CadastroSelecionado?.latitudeInicio && CadastroSelecionado?.longitudeInicio">{{
                                        CadastroSelecionado?.latitudeInicio }}, {{ CadastroSelecionado?.longitudeInicio
                                        }}</span>
                                    <span class="text-muted"
                                        *ngIf="!CadastroSelecionado?.latitudeInicio || !CadastroSelecionado?.longitudeInicio">Sem
                                        localização</span>
                                </div>

                                <a *ngIf="CadastroSelecionado?.latitudeInicio && CadastroSelecionado?.longitudeInicio"
                                    [href]="'https://www.google.com/maps?q=' + CadastroSelecionado?.latitudeInicio + ',' + CadastroSelecionado?.longitudeInicio"
                                    target="_blank" class="btn btn-outline-success btn-sm">
                                    <i class="bi bi-geo-alt-fill me-1"></i> Ver no mapa
                                </a>
                            </div>

                            <div class="info-box modern-card end-card">
                                <div class="card-header-small d-flex align-items-center mb-2">
                                    <i class="bi bi-flag-fill text-danger me-2 fs-4"></i>
                                    <h4 class="m-0">Fim do Cadastro</h4>
                                </div>

                                <label>Data/Hora:</label>
                                <div class="mb-2">
                                    <span>{{ CadastroSelecionado?.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                </div>

                                <label>Coordenadas:</label>
                                <div class="mb-3">
                                    <span class="coord-pill coord-end"
                                        *ngIf="CadastroSelecionado?.latitudeFim && CadastroSelecionado?.longitudeFim">{{
                                        CadastroSelecionado?.latitudeFim }}, {{ CadastroSelecionado?.longitudeFim
                                        }}</span>
                                    <span class="text-muted"
                                        *ngIf="!CadastroSelecionado?.latitudeFim || !CadastroSelecionado?.longitudeFim">Sem
                                        localização</span>
                                </div>

                                <a *ngIf="CadastroSelecionado?.latitudeFim && CadastroSelecionado?.longitudeFim"
                                    [href]="'https://www.google.com/maps?q=' + CadastroSelecionado?.latitudeFim + ',' + CadastroSelecionado?.longitudeFim"
                                    target="_blank" class="btn btn-outline-danger btn-sm">
                                    <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                                </a>
                            </div>
                        </div>

                        <div class="map-container cadastro-map-container">
                            <!-- existing map container (kept for compatibility) -->
                            <div id="mapCadastro" class="map"></div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Acompanhante</legend>
                        <div class="grid-3 mb-2">
                            <div>
                                <label>Nome:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.nomeAcompanhante || '-'" readonly>
                            </div>
                            <div>
                                <label>CPF:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.cpfAcompanhante ? maskCpf(CadastroSelecionado?.cpfAcompanhante || '') : '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Telefone:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.telefoneAcompanhante ? maskTelefone(CadastroSelecionado?.telefoneAcompanhante || '') : '-'"
                                    readonly>
                            </div>
                        </div>
                        <div>
                            <label>Assinatura do Acompanhante:</label>
                            <div class="signature-container">
                                <img *ngIf="CadastroSelecionado?.assinaturaAcompanhante?.url || CadastroSelecionado?.assinaturaAcompanhante"
                                    [src]="getSafeImageUrl(CadastroSelecionado?.assinaturaAcompanhante?.url || CadastroSelecionado?.assinaturaAcompanhante)"
                                    alt="Assinatura do Acompanhante" class="signature-image"
                                    (click)="openImageFrom(CadastroSelecionado?.assinaturaAcompanhante?.url || CadastroSelecionado?.assinaturaAcompanhante)">
                                <div *ngIf="!CadastroSelecionado?.assinaturaAcompanhante?.url && !CadastroSelecionado?.assinaturaAcompanhante"
                                    class="sem-dados-campo">
                                    Não informado
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend class="mb-2">Dados do Vistoriador</legend>
                        <div class="grid-2 mb-2">
                            <div>
                                <label>Nome:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="CadastroSelecionado?.nomeVistoriador || CadastroSelecionado?.nomeVistoriante || '-'"
                                    readonly>
                            </div>
                            <div>
                                <label>Data da Vistoria:</label>
                                <input type="text" class="form-control campo-readonly"
                                    [value]="formatDateTime(CadastroSelecionado?.dataCadastro || CadastroSelecionado?.dataRecadastramento) || '-'"
                                    readonly>
                            </div>
                        </div>
                        <div class="vistoriador-foto mb-2">
                            <div>
                                <label>Foto do Vistoriador</label>
                                <div class="foto-vistoriador">
                                    <img *ngIf="CadastroSelecionado?.fotoVistoriador || CadastroSelecionado?.fotoVistoriante"
                                        [src]="getSafeImageUrl(CadastroSelecionado?.fotoVistoriador || CadastroSelecionado?.fotoVistoriante)"
                                        alt="Foto do Vistoriador" class="foto-vistoriador"
                                        (click)="openImageFrom(CadastroSelecionado?.fotoVistoriador || CadastroSelecionado?.fotoVistoriante)">
                                    <div *ngIf="!CadastroSelecionado?.fotoVistoriador && !CadastroSelecionado?.fotoVistoriante"
                                        class="sem-dados-campo">
                                        Não disponível
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>Assinatura do Vistoriador:</label>
                            <div class="signature-container">
                                <img *ngIf="CadastroSelecionado?.assinaturaVistoriador || CadastroSelecionado?.assinaturaVistoriante?.url"
                                    [src]="getSafeImageUrl(CadastroSelecionado?.assinaturaVistoriador || CadastroSelecionado?.assinaturaVistoriante?.url)"
                                    alt="Assinatura do Vistoriador" class="signature-image"
                                    (click)="openImageFrom(CadastroSelecionado?.assinaturaVistoriador || CadastroSelecionado?.assinaturaVistoriante?.url)">
                                <div *ngIf="!CadastroSelecionado?.assinaturaVistoriador && !CadastroSelecionado?.assinaturaVistoriante?.url"
                                    class="sem-dados-campo">
                                    Não informado
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <div *ngIf="CadastroSelecionado?.analisadoPorNome && (CadastroSelecionado?.status === 'Validado' || CadastroSelecionado?.status === 'Invalido')"
                        class="d-flex justify-content-center mt-4 mb-2" role="status" aria-live="polite">

                        <!-- Unified modern card with analysis info + status stamp -->
                        <div class="unified-analysis-card">
                            <div class="unified-card-content">
                                <!-- Left side: Analysis info -->
                                <div class="analysis-section">
                                    <div class="analysis-header">
                                        <div class="analyst-icon">
                                            <i class="bi bi-person-check-fill"></i>
                                        </div>
                                        <div class="analyst-details">
                                            <div class="analyst-label">Analisado por</div>
                                            <div class="analyst-name">{{ CadastroSelecionado?.analisadoPorNome }}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="CadastroSelecionado?.dataHoraInicioAnalise" class="analysis-date">
                                        <i class="bi bi-calendar-check"></i>
                                        <span>{{ CadastroSelecionado?.dataHoraInicioAnalise | date: 'dd/MM/yyyy'
                                            }}</span>
                                        <span class="time-separator">•</span>
                                        <span>{{ CadastroSelecionado?.dataHoraInicioAnalise | date: 'HH:mm:ss' }}</span>
                                    </div>
                                </div>

                                <!-- Right side: Status stamp -->
                                <div class="status-section">
                                    <div *ngIf="CadastroSelecionado?.status === 'Validado'" class="stamp-pill validado"
                                        tabindex="0" aria-label="Registro validado">
                                        <div class="stamp-icon validado" aria-hidden="true"><i
                                                class="bi bi-patch-check-fill"></i></div>
                                        <div class="label">Validado</div>
                                    </div>

                                    <div *ngIf="CadastroSelecionado?.status === 'Invalido'" class="stamp-pill invalido"
                                        tabindex="0" aria-label="Registro inválido">
                                        <div class="stamp-icon invalido" aria-hidden="true"><i
                                                class="bi bi-x-octagon-fill"></i></div>
                                        <div class="label">Inválido</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="text-align: right; margin-top: 24px;">
                        <button type="button" class="btn btn-cancel" (click)="fecharFormulario()">
                            <i class="fas fa-times"></i> Fechar formulário
                        </button>
                    </div>
                </form>

                <!-- Modal de visualização de foto ampliada -->
                <div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto"
                    (click)="fecharModalFoto()">
                    <div class="modal-foto-content" (click)="$event.stopPropagation()">
                        <button type="button" class="btn-close-foto" (click)="fecharModalFoto()" aria-label="Fechar"
                            title="Fechar">
                            <i class="fas fa-times"></i>
                        </button>
                        <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada"
                            [style.transform]="'rotate(' + rotacaoFoto + 'deg)'"
                            [style.transition]="'transform 0.3s'">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>